import React from 'react';
import Slider from 'rc-slider';
import { StringToDouble } from 'utils';
import { numberFormat } from 'utils';

function RenderRangeFilter(props) {
  const { input, minMax } = props;

  const [min, setMin] = React.useState(0);
  const [max, setMax] = React.useState(100);
  const [valueData, setValueData] = React.useState([20, 50]);

  React.useEffect(() => {
    if (input.value) {
      setValueData(input.value);
    }
    if (minMax && !!minMax.length) {
      setMin(minMax[0]);
      setMax(minMax[1]);
    }
  }, []);

  function onSliderChange(value) {
    console.log(value)
    setValueData(value);
    // if(input.onChange) input.onChange(value)
  }

  function onSliderAfterChange(e) {
    // log('onSliderAfterChange', e);
    // setValue(value)
    if (input.onChange) input.onChange(e);
  }

  function onMinChange(e) {
    const { value } = e.target;
    console.log(value)
    let _val = value;
    if (value < min) _val = min;
    if (value > valueData[1]) _val = valueData[1];

    const _newData = [StringToDouble(_val), valueData[1]];
    setValueData(_newData);
  }
  function onMaxChange(e) {
    const { value } = e.target;
    let _val = value;
    const _newData = [valueData[0], StringToDouble(_val)];
    setValueData(_newData);
  }

  function _handleBlurMin() {
    let _val = valueData[0]
    if (_val > valueData[1]) _val = valueData[1];
    if (_val < min) _val = min;
    const _newData = [StringToDouble(_val), valueData[1]];
    setValueData(_newData);
    if (input.onChange) input.onChange(_newData);
  }

  function _handleBlurMax() {
    let _val = valueData[1]
    if (_val < valueData[0]) _val = valueData[0];
    if (_val > max) _val = max;
    const _newData = [valueData[0], StringToDouble(_val)];
    setValueData(_newData);
    if (input.onChange) input.onChange(_newData);
  }

  return (
    <div className="ranger-filter">
      <input
        type="text"
        value={valueData[0]}
        onChange={onMinChange}
        onFocus={(e) => e.target.select()}
        onBlur={_handleBlurMin}
      />
      <Slider
        {...input}
        range
        allowCross={false}
        value={valueData}
        min={min}
        max={max}
        onChange={onSliderChange}
        onAfterChange={onSliderAfterChange}
      />
      <input
        type="text"
        value={valueData[1]}
        onChange={onMaxChange}
        onFocus={(e) => e.target.select()}
        onBlur={_handleBlurMax}
      />
    </div>
  );
}

export default RenderRangeFilter;
